export default __webpack_public_path__ + "static/media/cardano.4114f714.svg";